'use strict';

var _ = require('lodash');
var tooltipTemplate = _.template(require('../templates/chart-forecast-profile-tooltip-template.html'));
var ChartForecastProfileViewController = function ChartForecastProfileViewController($scope, $filter, dataProviderService) {
  var rmMomentFormat = $filter('rmMomentFormat');
  $scope.metricLabels = ['ignore'];
  $scope.initChart = function () {
    if (!$scope.attributes) {
      return;
    }
    $scope.profileCreated = rmMomentFormat($scope.attributes.lastProcessedMoment, 'DATE_USER_SETTINGS');
    dataProviderService.getData($scope.attributes, $scope.quickFilterData, $scope.dimension).then(function (chartData) {
      $scope.legend = chartData.legend;
      $scope.verticalLineData = chartData.verticalLineData;
      $scope.renderChart(chartData.data);
    }, function () {
      $scope.renderChart();
    });
  };
  $scope.chartFormatters = {
    xAxisTickFormatter: function xAxisTickFormatter(d) {
      return d;
    },
    yAxisTickFormatter: function yAxisTickFormatter(d) {
      return d;
    },
    tooltipFormatter: function tooltipFormatter(d) {
      var data = _.map(d, function (val) {
        return _.extend({}, val, {
          demand: parseFloat(val.demand).toFixed(2)
        });
      });
      return tooltipTemplate({
        data: data,
        dtd: d[0].dtd
      });
    }
  };
  $scope.chartFormatters.tooltipFormatter.cssClass = 'demand-transparency-profile-chart-tooltip';
  function extendWithParent(point, parent) {
    return _.extend({
      interpolated: !!point.interpolated
    }, point, _.pick(parent, ['season', 'fill', 'caption', 'dayOfWeekGroup', 'source']));
  }
  $scope.interpolate = function (el, x) {
    var query = {
      dtd: x
    };
    var found = _.find(el.curveData, query);
    if (found) {
      return extendWithParent(found, el);
    }
    var sorted = _.sortBy(el.curveData, 'dtd');
    var ind = _.sortedIndexBy(sorted, query, 'dtd');
    if (ind === 0 || ind === sorted.length) {
      return extendWithParent(sorted[ind] || sorted[ind - 1], el);
    }
    var first = sorted[ind - 1];
    var second = sorted[ind];
    var res = {
      dtd: x,
      demand: (first.demand + (second.demand - first.demand) * (x - first.dtd) / (second.dtd - first.dtd)).toFixed(2),
      interpolated: true
    };
    return extendWithParent(res, el);
  };
};
ChartForecastProfileViewController.$inject = ['$scope', '$filter', 'ChartForecastProfileViewDataProviderService'];
module.exports = ChartForecastProfileViewController;